(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kremo-care-faq"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('kremo-care-faq')) return;

    class KremoCareFaq extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';
        this.items = Array.from(this.querySelectorAll('details'));
        this.items.forEach((item) => {
          item.addEventListener('toggle', () => {
            if (!item.open) return;
            this.items.forEach((other) => {
              if (other !== item) other.open = false;
            });
          });
        });
      }
    }

    customElements.define('kremo-care-faq', KremoCareFaq);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kremo-material-atelier"]) return;
  try {
    
  (() => {
    if (customElements.get('kremo-material-atelier')) return;

    class KremoMaterialAtelier extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.visualPanels = Array.from(this.querySelectorAll('[data-visual]'));
        this.detailPanels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
        this.details = Array.from(this.querySelectorAll('.kremo-material-atelier__mobile-item'));

        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.activate(index));
          tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
        });

        this.details.forEach((detail) => {
          detail.addEventListener('toggle', () => {
            if (!detail.open) return;
            this.details.forEach((other) => {
              if (other !== detail) other.open = false;
            });
          });
        });
      }

      activate(index, focus = false) {
        this.tabs.forEach((tab, tabIndex) => {
          const active = tabIndex === index;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.tabIndex = active ? 0 : -1;
          if (active && focus) tab.focus();
        });

        this.visualPanels.forEach((panel, panelIndex) => {
          const active = panelIndex === index;
          panel.hidden = !active;
          panel.classList.toggle('is-active', active);
        });

        this.detailPanels.forEach((panel, panelIndex) => {
          const active = panelIndex === index;
          panel.hidden = !active;
          panel.classList.toggle('is-active', active);
        });
      }

      onKeydown(event, index) {
        let nextIndex = index;
        if (event.key === 'ArrowDown' || event.key === 'ArrowRight') nextIndex = (index + 1) % this.tabs.length;
        else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
        else if (event.key === 'Home') nextIndex = 0;
        else if (event.key === 'End') nextIndex = this.tabs.length - 1;
        else return;

        event.preventDefault();
        this.activate(nextIndex, true);
      }
    }

    customElements.define('kremo-material-atelier', KremoMaterialAtelier);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
